/* Mega menu */
const handleMegaMenu = () => {
	// Check if mega menu exists on the page
	const megaMenu = document.querySelector('.wps-mega-menu-content');
	if (megaMenu === null) {
		return;
	}

	// Check if admin bar exists
	const adminBar = document.querySelector('#wpadminbar');

	// Get header top position and height
	const header = document.querySelector('.site-header');
	const headerHeight = header.offsetHeight;

	// Set mega menu top position based on the admin bar height
	if (adminBar !== null) {
		const adminBarHeight = adminBar.offsetHeight;
		megaMenu.style.top = `${adminBarHeight + headerHeight}px`;
	} else {
		megaMenu.style.top = `${headerHeight}px`;
	}

	const megaMenuTriggerIcon = document.querySelector(
		'.wps-mega-menu-trigger .wps-mega-menu__inner .icon-container',
	);

	if (megaMenuTriggerIcon === null) {
		return;
	}

	megaMenuTriggerIcon.addEventListener('click', () => {
		if (!document.body.classList.contains('wps-mega-menu-is-visible')) {
			megaMenuTriggerIcon.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.1875 19.3125L12 13.0781L5.76562 19.3125C5.48438 19.5938 5.01562 19.5938 4.6875 19.3125C4.40625 18.9844 4.40625 18.5156 4.6875 18.2344L10.9219 12L4.73438 5.8125C4.40625 5.53125 4.40625 5.0625 4.73438 4.73438C5.01562 4.45312 5.48438 4.45312 5.76562 4.73438L12 10.9688L18.1875 4.73438C18.4688 4.45312 18.9375 4.45312 19.2656 4.73438C19.5469 5.0625 19.5469 5.53125 19.2656 5.8125L13.0312 12L19.2656 18.2344C19.5469 18.5156 19.5469 18.9844 19.2656 19.3125C18.9375 19.5938 18.4688 19.5938 18.1875 19.3125Z" fill="#fff"/></svg>`;
		} else {
			megaMenuTriggerIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24" aria-hidden="true" focusable="true"><path d="M0 8v1h24V7H0v1"></path><path d="M0 16v1h17v-2H0v1"></path></svg>`;
		}
	});
};

export default handleMegaMenu;
